import { InlineTextField } from '@care/react-component-lib';
import { InputAdornment, Skeleton } from '@mui/material';
import React from 'react';
import { AddressInput as AddressInputType } from '@care/seeker-react-components/dist/components/shared/SeekerLocation/types';
import { Icon24InfoLocation } from '@care/react-icons';
import { GoogleMaps } from '@care/seeker-react-components';

export interface LocationState {
  zipcode: string;
  latitude?: number | null;
  longitude?: number | null;
  city?: string;
  state?: string;
}

export interface ExploreLocationSearchProps {
  isLoading: boolean;
  address: LocationState;
  onChange: (address: AddressInputType) => void;
}

const ExploreLocationSearch: React.FC<ExploreLocationSearchProps> = ({
  address,
  isLoading,
  onChange,
}) => {
  const prePopulatedZip =
    !address?.city || !address.state ? address?.zipcode : `${address.city}, ${address.state}`;

  if (isLoading) {
    return (
      <Skeleton
        data-testid="explore-location-search-loader"
        variant="rounded"
        sx={{ borderRadius: '12px', width: '100%', height: '100%' }}
      />
    );
  }

  return (
    <GoogleMaps.ZipCodeAddressSearchViewAutoComplete
      searchByCityOrState
      blurOnSelect
      setCareLocation={() => {}}
      setSeekerAddress={onChange}
      setShowAppSuite={() => {}}
      initialValue={prePopulatedZip}
      renderInput={(params: { InputProps: any }) => {
        return (
          <InlineTextField
            {...params}
            placeholder="City, State, Address or ZIP code"
            label="Location"
            InputLabelProps={{ sx: { display: 'none' } }}
            value={prePopulatedZip}
            id="location-search"
            InputProps={{
              sx: { p: 0 },
              ...params.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  <Icon24InfoLocation />
                </InputAdornment>
              ),
            }}
          />
        );
      }}
    />
  );
};

export default ExploreLocationSearch;
